<template>
  <div>
    <loading v-if="!dataLoaded"></loading>
    <v-container fluid style="max-width: 1480px" class="pb-default" v-else>
      <v-row class="mt-sm-2">
        <v-col cols="12" :md="6">
          <el-module-list
              :modules="practiceModules"
              :title="$t('el.practiceModules')"
              :subTitle1="$t('el.practiseSubTitle1')"
              :subTitle2="$t('el.practiseSubTitle2')"
          ></el-module-list>
        </v-col>
        <v-col :xs="12" :md="6">
          <el-module-list :modules="exams" :title="$t('el.exam')" :subTitle1="$t('el.examSubTitle1')"
                          :subTitle2="$t('el.examSubTitle2')"></el-module-list>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import common from '@/mixins/common';
import {mapState} from 'vuex';
import ElModuleList from './ElearningModuleList';
import Loading from '@/components/container/Loading';

export default {
  name: 'ELearningEntry',
  mixins: [common],
  components: {ElModuleList, Loading},

  computed: {
    ...mapState('elearning', ['modules', 'userStateByModuleId', 'dataLoaded']),
    practiceModules() {
      return this.getModulesOfType(1);
    },
    exams() {
      return this.getModulesOfType(0);
    },
  },
  methods: {
    getModulesOfType(isPracticeValue) {
      let instance = this.$route.params.instance;
      return this.modules.filter((m) => m.instance == instance && m.is_practice === isPracticeValue).sort((a, b) => a.sort - b.sort);
    },
  },
};
</script>
